import API from '../api';

// Audit Logs API
export const auditLogsApi = {
  getAll: (params = {}) => API.get('/audit-logs', { params }),
  getById: (id) => API.get(`/audit-logs/${id}`),
  create: (data) => API.post('/audit-logs', data),
  update: (id, data) => API.put(`/audit-logs/${id}`, data),
  delete: (id) => API.delete(`/audit-logs/${id}`),
  search: (query) => API.get(`/audit-logs/search?q=${encodeURIComponent(query)}`)
};

// Tariffs API
export const tariffsApi = {
  getAll: (params = {}) => API.get('/tariffs', { params }),
  getById: (id) => API.get(`/tariffs/${id}`),
  create: (data) => API.post('/tariffs', data),
  update: (id, data) => API.put(`/tariffs/${id}`, data),
  delete: (id) => API.delete(`/tariffs/${id}`),
  search: (query) => API.get(`/tariffs/search?q=${encodeURIComponent(query)}`)
};

// Provinces API
export const provincesApi = {
  getAll: (params = {}) => API.get('/provinces', { params }),
  getById: (id) => API.get(`/provinces/${id}`),
  create: (data) => API.post('/provinces', data),
  update: (id, data) => API.put(`/provinces/${id}`, data),
  delete: (id) => API.delete(`/provinces/${id}`),
  search: (query) => API.get(`/provinces/search?q=${encodeURIComponent(query)}`),
  importExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    // Let the browser set Content-Type with boundary for multipart/form-data
    return API.post('/provinces/import', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  }
};

// Districts API
export const districtsApi = {
  getAll: (params = {}) => API.get('/districts', { params }),
  getById: (id) => API.get(`/districts/${id}`),
  getByProvinceId: (provinceId) => API.get(`/districts/province/${provinceId}`),
  create: (data) => API.post('/districts', data),
  update: (id, data) => API.put(`/districts/${id}`, data),
  delete: (id) => API.delete(`/districts/${id}`),
  search: (query) => API.get(`/districts/search?q=${encodeURIComponent(query)}`)
};

// Brands API
export const brandsApi = {
  getAll: (params = {}) => API.get('/brands', { params }),
  getById: (id) => API.get(`/brands/${id}`),
  create: (data) => API.post('/brands', data),
  update: (id, data) => API.put(`/brands/${id}`, data),
  delete: (id) => API.delete(`/brands/${id}`),
  search: (query) => API.get(`/brands/search?q=${encodeURIComponent(query)}`)
};

// Colors API
export const colorsApi = {
  getAll: (params = {}) => API.get('/colors', { params }),
  getById: (id) => API.get(`/colors/${id}`),
  create: (data) => API.post('/colors', data),
  update: (id, data) => API.put(`/colors/${id}`, data),
  delete: (id) => API.delete(`/colors/${id}`),
  search: (query) => API.get(`/colors/search?q=${encodeURIComponent(query)}`)
};

// Barriers API (Barrier System Integration Service)
export const barriersApi = {
  getAll: (params = {}) => API.get('/barriers', { params }),
  getById: (id) => API.get(`/barriers/${id}`),
  create: (data) => API.post('/barriers', data),
  update: (id, data) => API.put(`/barriers/${id}`, data),
  delete: (id) => API.delete(`/barriers/${id}`),
  search: (query) => API.get(`/barriers/search?q=${encodeURIComponent(query)}`),
  // Barrier actions aligned with backend
  test: (id) => API.post(`/barriers/${id}/test`),
  open: (id, payload = {}) => API.post(`/barriers/${id}/open`, payload),
  close: (id, payload = {}) => API.post(`/barriers/${id}/close`, payload),
  events: (id, params = {}) => API.post(`/barriers/${id}/events`, params),
  stats: (id, params = {}) => API.get(`/barriers/${id}/stats`, { params }),
  // System level endpoints
  status: () => API.get('/barriers/status'),
  testConnection: () => API.post('/barriers/test-connection'),
  sync: () => API.post('/barriers/sync'),
};

const settingsApi = {
  auditLogsApi,
  tariffsApi,
  provincesApi,
  districtsApi,
  brandsApi,
  colorsApi,
  barriersApi
};

export default settingsApi;
